var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-icon-white",class:( _obj = {}, _obj[_vm.direction + '-arrow-icon-white'] = true, _obj )},[_c('i-arrow',{class:( _obj$1 = {}, _obj$1[_vm.color + '-color'] = true, _obj$1 ),attrs:{"title":null}})],1)
var _obj;
var _obj$1;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b21f50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/ArrowIconWhite.vue
// module id = null
// module chunks = 